/**
 * External calendar credentials must be owned by a trusted server boundary.
 *
 * The legacy browser implementation receives provider refresh/access tokens and
 * calls Google Calendar and Microsoft Graph directly. Keep every connected
 * environment fail-closed until a server token vault and audited provider proxy
 * replace that implementation.
 */
export const CALENDAR_SERVER_INTEGRATION_AVAILABLE = false;

export const CALENDAR_SERVER_INTEGRATION_MESSAGE =
  'Calendar connections are unavailable until the server-managed OAuth service is deployed.';

